import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon } from "@b2bportal/core-ui";
import { FLIGHTS_SEARCH_PATH } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FlightSearch } from "@tenant/flights";
import {
  FlightRawEventName,
  useEmitCoreFlightRawEventOnce,
} from "../../../../tracking";
import defaultStyles from "./HomePageFlightSearch.module.scss";

export interface HomePageFlightSearchComponentProps
  extends PlatformComponentProps {
  onMobileRedirect?: () => void;
  onSearch?: () => void;
}

export const HomePageFlightSearch = ({
  onMobileRedirect,
  onSearch,
}: HomePageFlightSearchComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.HomePageFlightSearch;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  useEmitCoreFlightRawEventOnce({ name: FlightRawEventName.ViewedAirSearch });

  const navigate = useNavigate();

  const handleMobileRedirect = useCallback(() => {
    onMobileRedirect ? onMobileRedirect() : navigate(FLIGHTS_SEARCH_PATH);
  }, [navigate]);

  return (
    <div className={block}>
      <div className={cn("search")}>
        <FlightSearch onSearch={onSearch} />
      </div>
      <div className={cn("search-entry")}>
        <button
          onClick={() => handleMobileRedirect()}
          className={cn("start-flight-search-button")}
        >
          <Icon
            iconName={IconNameEnum.searchForFlights}
            className={cn("button-icon")}
          />
          {t("core-flights.search.mobileSearch.startSearch")}
        </button>
      </div>
    </div>
  );
};
